export function gridFields() {
  return Object.freeze([
      {
        key: 'id',
        label: 'ID',
        filterable:true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'status',
        label: 'Status',
        filterable:true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'messagesRelatedCount',
        label: 'Relations',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'received',
        label: 'Received',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'processed',
        label: 'Processed',
        form: {
          type: 'input'
        }
      },
      {
        key: 'request',
        label: 'Request',
        form: {
          type: 'input'
        }
      },
      {
        key: 'response',
        label: 'Response',
        form: {
          type: 'input'
        }
      },
      {
        key: 'type',
        label: 'Message Type',
        filterable:true,
        form: {
          type: 'select',
          options: [
            { value: '', text: 'lbl.basic.select.one' },
            { value: 'T', text: 'lbl.systemParameters.text' },
            { value: 'D', text: 'lbl.basic.date' },
            { value: 'N', text: 'lbl.systemParameters.number' },
            { value: 'J', text: 'lbl.systemParameters.json' },
            { value: 'X', text: 'lbl.systemParameters.xml' },
            { value: 'U', text: 'lbl.systemParameters.url' },
            { value: 'B', text: 'lbl.systemParameters.boolean' }
          ]
        },
      }
  ]);
}

// class
export const Model = function (...args) {
  gridFields().forEach(item => {
    this[item.key] = item.default || '';
  })
}

// export const fields = Object.freeze(Object.keys(new SystemParameters()).map(i => 'entity.' + i));

export const filter = gridFields()
  .filter(v => v.filterable)
  .reduce((tar, v) => {
    tar[`${v.key}Filter`] = '';
    return tar
  }, {})
export const filterFields = gridFields().filter(v => v.filterable).map(v => `filter.${v.key}`)